/** @jsxImportSource @emotion/react */
import { FC } from 'react'
import { observer } from 'mobx-react-lite'
import { BoxStore } from '../../stores/RussianPoker/Box.store'
import { EBettingBoxLayoutMode } from '../../stores/RussianPoker/BoxUI.store'
import { InitialBoxView } from './InitialBoxView'
import { SelectedBoxView } from './SelectedBoxView'
import { CompactBoxView } from './CompactBoxView'
import { StakedBoxView } from './StakedBoxView'

export const BettingBox: FC<{ box: BoxStore }> = observer((props) => {
  const { ui } = props.box
  const { layout } = ui

  switch (layout) {
    case EBettingBoxLayoutMode.INITIAL:
      return <InitialBoxView {...props} />
    case EBettingBoxLayoutMode.SELECTED:
      return <SelectedBoxView {...props} />
    case EBettingBoxLayoutMode.COMPACT:
      return <CompactBoxView {...props} />
    case EBettingBoxLayoutMode.STAKED:
      return <StakedBoxView {...props} />
    default:
      return <InitialBoxView {...props} />
  }
})
